module.exports = __webpack_public_path__ + "img/chagora_yes.493c1a51.png";